import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar as faSparkles } from "@fortawesome/free-solid-svg-icons"
import AiChat from "./chatwindow"

const aichatButtonStyle: React.CSSProperties = {
  position: "fixed",
  bottom: "1.5rem",
  right: "1.5rem",
  backgroundColor: "var(--badge-filled-neutral-color, #fff)",
  cursor: "pointer",
  width: "3rem",
  height: "3rem",
  margin: "0 8px",
  padding: "0",
  borderRadius: "12px",
  border: "none",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1001,
  boxSizing: "border-box"
}

const parseParamsFromPath = () => {
  const pathname = window.location.pathname
  const buildingMatch = pathname.match(/\/building\/([^/]+)/)
  const equipmentMatch = pathname.match(/\/equipment\/([^/]+)/)
  return {
    buildingId: buildingMatch?.[1] ?? "",
    equipmentId: equipmentMatch?.[1] ?? ""
  }
}

const AIChat: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  const { buildingId, equipmentId } = parseParamsFromPath()

  return (
    <>
      <button
        style={aichatButtonStyle}
        aria-label="AI Chat"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <FontAwesomeIcon icon={faSparkles} />
      </button>
      <AiChat
        isVisible={isOpen}
        onWindowClose={() => setIsOpen(false)}
        buildingId={buildingId}
        equipmentId={equipmentId}
      />
    </>
  )
}

export default AIChat

